export const TIPOS_DE_ASSEDIOS = {
  SEXUAL: "SEXUAL",
  MORAL: "MORAL",
  AMBOS: "AMBOS",
} as const;

export type TipoDeAssedio = keyof typeof TIPOS_DE_ASSEDIOS;
